module.exports = __webpack_public_path__ + "img/ig.2288e8e6.svg";